/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Backup_Llm_LabelInputs */

const en_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup AI Model (optional)`)
};

const fr_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle d'IA de sauvegarde (facultatif)`)
};

const de_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup-KI-Modell (optional)`)
};

const it_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello di intelligenza artificiale di backup (opzionale)`)
};

const ru_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резервная модель ИИ (опционально)`)
};

const es_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo de IA de respaldo (opcional)`)
};

const zh_cn2_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`备用AI模型（可选）`)
};

const ja_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バックアップAIモデル（オプション）`)
};

const hi_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैकअप एआई मॉडल (वैकल्पिक)`)
};

const pt_pt2_ad_backup_llm_label = /** @type {(inputs: Ad_Backup_Llm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo de IA de backup (opcional)`)
};

/**
* | output |
* | --- |
* | "Backup AI Model (optional)" |
*
* @param {Ad_Backup_Llm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_backup_llm_label = /** @type {((inputs?: Ad_Backup_Llm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Backup_Llm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_backup_llm_label(inputs)
	if (locale === "de") return de_ad_backup_llm_label(inputs)
	if (locale === "it") return it_ad_backup_llm_label(inputs)
	if (locale === "ru") return ru_ad_backup_llm_label(inputs)
	if (locale === "es") return es_ad_backup_llm_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_backup_llm_label(inputs)
	if (locale === "ja") return ja_ad_backup_llm_label(inputs)
	if (locale === "hi") return hi_ad_backup_llm_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_backup_llm_label(inputs)
	return en_ad_backup_llm_label(inputs)
});